// Drop the patient email from the iframe URL before analytics boots. GA records
// window.location as the document location, and the email is not kept in
// sessionStorage, so a refresh already starts without it.
export function stripEmailFromLocation (location, history) {
  const params = new URLSearchParams(location.search)
  const email = params.get('email')
  if (!params.has('email')) return { params, email }
  params.delete('email')
  const query = params.toString()
  const nextUrl = location.pathname + (query ? `?${query}` : '') + location.hash
  history.replaceState(history.state, '', nextUrl)
  return { params, email }
}

function urlParam (browser, name) {
  const search = browser.location && browser.location.search
  if (!search) return null
  return new URLSearchParams(search).get(name)
}

export function redirectToExternalReview (url, browser = window) {
  // Email surveys navigate the parent page directly. SMS and the website
  // button use the top window, which is what the parent did after the old
  // widget asked it to redirect.
  const utmMedium = urlParam(browser, 'utm_medium')
  const target = utmMedium != null && utmMedium.toLowerCase() === 'email'
    ? (browser.parent || browser)
    : (browser.top || browser.parent || browser)

  try {
    if (!target.location || typeof target.location.replace !== 'function') {
      throw new Error('Top-level navigation is unavailable')
    }
    target.location.replace(url)
    return true
  } catch (_) {
    // Popup blockers return null instead of throwing. Tell the caller so it
    // can give the patient a normal, visible link as a final fallback.
    try {
      return browser.open(url, '_blank') !== null
    } catch (_) {
      return false
    }
  }
}
